(function() {
  'use strict';

  angular.module('app').factory('SendMessageService', SendMessageService);

  SendMessageService.$inject = [
    '$rootScope',
    'API',
    '$filter',
    'blockUI',
    '$uibModal',
    '$timeout',
    'CouponsService',
    'MessageService',
    'SettingsService'];

  function SendMessageService(
      $rootScope,
      API,
      $filter,
      blockUI,
      $uibModal,
      $timeout,
      CouponsService,
      MessageService,
      SettingsService) {
    var service = {};

    function getAllUserIds(couponsList) {
      var usersIds = [];
      couponsList.forEach(function(coupon) {
        if (coupon.user_id && usersIds.indexOf(coupon.user_id) === -1) {
          usersIds.push(coupon.user_id);
        }
      });
      return usersIds;
    }

    service.popupSendMessage = function($scope, batch) {
      $rootScope.getBusinessStatus();
      var isInCust = appConfig.platformParams.main_site.en === 'incust.com';

      $scope.modalSendMessage = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/templates/modal.customer.sendmessage.html',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;

          popup.model = {};
          popup.options = {};

          popup.message_types = [
            {id: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
            {id: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
            {id: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
            {id: 'viber-sms', title: 'TEXT_VIBER_SMS'},
            {id: 'push', title: 'TEXT_PUSH'},
            {id: 'chatbot', title: 'TEXT_CHATBOT'},
            // {id: 'viber', title: 'TEXT_VIBER'},
            {id: 'sms', title: 'TEXT_SMS'},
            {id: 'email', title: 'TEXT_EMAIL'}
          ];

          if(isInCust) {
            popup.message_types.push({id: 'chatbot', title: 'TEXT_CHATBOT_7LOC'})
          }

          SettingsService.GetPlatformParams(function(success, response) {
            if (success) {
              if (!!response.allow_messages_to_external_system) {
                popup.message_types.push({
                  id: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'
                });
              }

            }
          });
          popup.type = 'push-chatbot-viber-sms';
          popup.model.step = 0;
          $rootScope.REQUEST_ABORT_PENDING = false;

          // Id всех покупателей из выборки
          var allUsersIds = [];

          // Если количество всех купонов больше чем загружено в данный момент, то загружаем id всех пользователей
          if ($scope.data.summaryCoupons.total_rows_count !== $scope.data.couponsList.length) {
            var blockPopupSendMessage = blockUI.instances.get('popupSendMessage');

            var allCouponsParams = angular.copy({
              batch_id: batch.id,
              loyalty_id: batch.loyalty_id
            });
            allCouponsParams = Object.assign(allCouponsParams, $scope.params.coupons);

            blockPopupSendMessage.start();
            CouponsService.AllIds(allCouponsParams, function(success, response) {
              if (success) {
                allUsersIds = response;
                popup.usersCount = allUsersIds.length;
              }
              blockPopupSendMessage.stop();
            });
          } else {
            allUsersIds = getAllUserIds($scope.data.couponsList);
            popup.usersCount = allUsersIds.length;
          }

          popup.selectedCount = Object.keys($scope.selectedCouponsUserIds).length;
          popup.sendTo = popup.selectedCount === 0 ? 'all' : 'selected';

          popup.onOk = function() {
            var post_data = {
              loyalty_id: batch.loyalty_id,
              message: popup.message,
              type: popup.type,
              bonuses_decimal_digits: 2
            };

            popup.model.chunk_size = 25;

            popup.model.request_progress = 0.01;

            $scope.sendingResult = {cost: 0, success: 0, error: 0, priceCalculated: false};
            popup.model.sendingResult = $scope.sendingResult;

            if (popup.sendTo === 'all') {
              popup.model.users = angular.copy(allUsersIds);
            } else if (popup.sendTo === 'selected') {
              popup.model.users = Object.keys($scope.selectedCouponsUserIds);
            }
            popup.model.total_elements = popup.model.users.length;

            var request;
            if (popup.model.step === 0) {
              request = MessageService.SendPrice;
              popup.model.chunk_size = 100;
              popup.options = {price_calc: true};
              popup.model.step = 1;
            } else if (popup.model.step === 1) {
              request = MessageService.Send;
              popup.options = {error_report: true};
              popup.model.chunk_size = 25;
            }

            processRequest($scope, popup, post_data, request, $uibModalInstance, popup.options);

            $scope.$watch(angular.bind(this, function(model) {
              return this.model;
            }), function(newValue, oldValue) {
              if (newValue) {
                $timeout(function() {
                  if (newValue.step === 1 && $scope.sendingResult.priceCalculated) {
                    $rootScope.getBusinessStatus();
                    $timeout(function() {
                      delete popup.model.request_progress;

                      popup.model.sendingResult = $scope.sendingResult;

                      if ($scope.sendingResult.cost >
                          ($rootScope.ENV.business.status.account_balance + $rootScope.ENV.business.status.credit_limit))
                        popup.model.can_not_be_send = true;
                    }, 300);
                  }
                });
              }
            }, true);
          };

          popup.onAddMacros = function(m) {
            if (popup.message)
              popup.message += ' {{' + m + '}}';
            else
              popup.message = '{{' + m + '}}';
          };

          popup.onRequestAbort = function() {
            $rootScope.REQUEST_ABORT_PENDING = true;
            popup.model.request_progress = 0;
          };

          popup.onPaymetnLinkClick = function() {
            $uibModalInstance.close();
            $location.path('/payment');
          };

          popup.onCancel = function(exit) {
            popup.model.can_not_be_send = false;

            if (popup.model.sendingResult)
              popup.model.sendingResult.error = 0;

            if (!exit)
              popup.model.step -= 1;

            if (exit || popup.model.step < 0)
              $uibModalInstance.close();
          };
        }
      });
    };

    function processRequest($scope, popup, post_data, request, modal, options) {
      $scope.model.inlineMessage = '';

      popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
      post_data.users = popup.model.chunk;

      if (!post_data.type) {
        post_data.type = popup.model.delivery_method;
      }

      function handleResult(success, data) {
        if (!$rootScope.REQUEST_ABORT_PENDING) {
          if (success) {
            popup.model.request_progress += popup.model.chunk.length / popup.model.total_elements * 100;
            if (options && options.error_report) {
              $scope.sendingResult.success += data.success;
              $scope.sendingResult.error += data.error;
              $scope.sendingResult.no_processed += data.no_processed;
            }

            if (options && options.price_calc) {
              $scope.sendingResult.cost += data.cost;
              $scope.sendingResult.error += data.error;
              $scope.sendingResult.no_processed += data.no_processed;
            }

            if (options && options.error_log && data.error.length > 0) {
              $scope.sendingResult.error_log = $scope.sendingResult.error_log.concat(data.error);
            }

            if (popup.model.users.length > 0) {
              popup.model.chunk = popup.model.users.splice(0, popup.model.chunk_size);
              post_data.users = popup.model.chunk;

              request(post_data, handleResult);
            } else {
              if (!options || (options && !options.price_calc)) {
                modal.close();
              }

              if (options && options.price_calc) {
                $scope.sendingResult.priceCalculated = true;
              }

              if (options && ($scope.sendingResult && $scope.sendingResult.error_log && $scope.sendingResult.error_log.length > 0 ||
                  options.error_report && !options.price_calc)
              ) {
                modal.close();
                popupOperationResult($scope.sendingResult, options);
              }

            }
          }
        } else {
          $rootScope.REQUEST_ABORT_PENDING = false;
        }
      }

      request(post_data, handleResult);
    }

    function popupOperationResult($scope, options) {
      $scope.modalOperationResult = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/templates/modal.customer.operation_result.html',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;

          popup.result = $scope.sendingResult;
          popup.options = options;

          popup.onErrosLogExport = function(format) {
            var file_name = $rootScope.ENV.business.code + '_refill_errors_' + moment().format('YYYY-MM-DD_HH:mm:ss');

            switch (format) {
              case 'XLSX':
                alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [popup.result.error_log]);
                break;
              case 'XLS':
                alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [popup.result.error_log]);
                break;
              case 'CSV':
                alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [popup.result.error_log]);
                break;
            }
          };

          popup.onOk = function() {
            $uibModalInstance.close();
          };
        }
      });
    }

    return service;
  }

})();
